module.exports = __webpack_public_path__ + "static/media/prev.d2c1dbfd.svg";